/**
 * This function is used to ensure that I want today's date without time information 00:00:00:00 (all zero).
 * There was an issue where milisecond data can't be zero when I set it via setHours method (0, 0, 0, 0)
 * and the result was something like 00:00:00:00004.
 * @returns Date
 */
function getNowDate() {
  const now = new Date()
  const nowDate = new Date(now.toDateString())

  return nowDate
}

function buildStartDate(dateDiff = 0) {
  const startDate = getNowDate()
  startDate.setDate(startDate.getDate() - dateDiff)

  return startDate
}

function buildEndDate(dateDiff = 0) {
  const endDate = getNowDate()
  endDate.setDate(endDate.getDate() - dateDiff)
  endDate.setHours(23, 59, 59, 999)

  return endDate
}

export const tableFilterFields = {
  computed: {
    tableFilterFields() {
      return [
        {
          name: 'created_on',
          isShow: true,
          label: this.$t('costManagement.fields.createdDate'),
          type: 'date-picker',
          datepickerType: 'date',
          valueType: 'YYYY-MM-DD',
          format: 'DD MMM YYYY',
          titleFormat: 'DD MMM YYYY',
          rangeSeparator: ' - ',
          range: true,
          draft: true,
          confirm: true,
          confirmText: 'Terapkan',
          disabledDate: (date) => {
            return date > new Date()
          },
          shortcuts: this.dateFilterShortcuts,
        },
        {
          name: 'date',
          isShow: true,
          label: this.$t('costManagement.fields.transactionDate'),
          type: 'date-picker',
          datepickerType: 'date',
          valueType: 'YYYY-MM-DD',
          format: 'DD MMM YYYY',
          titleFormat: 'DD MMM YYYY',
          rangeSeparator: ' - ',
          range: true,
          draft: true,
          confirm: true,
          confirmText: 'Terapkan',
          shortcuts: this.dateFilterShortcuts,
        },
        {
          name: 'latest_exported_on',
          isShow: true,
          label: this.$t('costManagement.filter.downloadAccurate'),
          type: 'choose-button',
          default: null,
          options: [
            {
              key: 'all',
              label: this.$t('costManagement.filter.all'),
              value: null
            },
            {
              key: 'downloaded',
              label: this.$t('costManagement.filter.downloaded'),
              value: 'is_not'
            },
            {
              key: 'notdownloaded',
              label: this.$t('costManagement.filter.notDownloaded'),
              value: 'is'
            }
          ]
        }
      ]
    },
    dateFilterShortcuts() {
      return [
        {
          text: this.$t("global.time.today"),
          onClick: () => {
            return [buildStartDate(), buildEndDate()]
          },
        },
        {
          text: this.$t("global.time.yesterday"),
          onClick: () => {
            return [buildStartDate(1), buildEndDate(1)]
          },
        },
        {
          text: this.$t("global.time.last3Days"),
          onClick: () => {
            return [buildStartDate(3), buildEndDate()]
          },
        },
        {
          text: this.$t("global.time.last7Days"),
          onClick: () => {
            return [buildStartDate(7), buildEndDate()]
          },
        },
      ].map((shortcut) => ({ ...shortcut, value: shortcut.onClick }))
    }
  }
}
